import * as React from "react";
import { Image, Text, Stack, ITextStyles, getTheme, IStackStyles, IImageStyles } from "office-ui-fabric-react";

import { FontSizes } from "@uifabric/fluent-theme";
import { FontWeights, mergeStyles } from "office-ui-fabric-react";

const theme = getTheme()

const containerS: IStackStyles = {
    root: {
        minWidth: "230px",
    }
}

const imageS: Partial<IImageStyles> = {
    root: {
        marginRight: "15px"
    }
}

const textS: ITextStyles = {
    root: {
        fontSize: FontSizes.size16,
        fontWeight: FontWeights.semibold,
        color: theme.palette.white,
      },
}

const Logo: React.FC = () => {
  return (
    <Stack horizontal styles={containerS}>
      <Text styles={textS}>Kancelaria</Text>
    </Stack>
  );
};

export default Logo;
